import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { componentTokens } from "@accredo/fe-shared/theme/tokens/components.js";
import PropTypes from "prop-types";

UserMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.elementType,
      onClick: PropTypes.func,
      divider: PropTypes.bool,
    })
  ).isRequired,
};

export default function UserMenu({ anchorEl, open, onClose, menuItems }) {
  if (!menuItems) {
    return null;
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            backgroundColor: componentTokens.userMenu.backgroundColor,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              backgroundColor: componentTokens.userMenu.arrowBackgroundColor,
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      {menuItems.map((item, index) => {
        if (item.divider) {
          return <Divider key={index} />;
        }

        const isLastItem = index === menuItems.length - 1;

        return (
          <MenuItem
            key={index}
            onClick={() => {
              item.onClick();
              onClose();
            }}
            sx={{
              px: 3,
              py: 1,
              mb: isLastItem ? 0 : 1.5,
            }}
          >
            {item.icon && (
              <ListItemIcon>
                <item.icon
                  sx={{
                    color: componentTokens.userMenu.icon.color,
                    fontSize: componentTokens.userMenu.icon.size,
                  }}
                />
              </ListItemIcon>
            )}
            <ListItemText
              sx={{
                "& .MuiListItemText-primary": {
                  color: componentTokens.userMenu.text.color,
                  fontWeight: componentTokens.userMenu.text.fontWeight,
                },
              }}
            >
              {item.label}
            </ListItemText>
          </MenuItem>
        );
      })}
    </Menu>
  );
}
